export function slashOpensSearch(active: Element | null): boolean {
  if (!active) return true;
  const on = active as HTMLElement;
  return !(on.tagName === "INPUT" || on.tagName === "TEXTAREA" || on.isContentEditable);
}
